import { useTranslation } from '../../../../utils/useTranslation';
import { IconShare } from '../../../icon/IconShare';
import { Button } from '../../../input/Button';
import { SiteUrlButtonProps } from '../types';
import { ClickOutButton } from './ClickoutButton';

export const SiteUrlButton = ({
    business,
    onClickOutClick,
    onShare,
    isBlogger,
    ...other
}: SiteUrlButtonProps) => {
    const t = useTranslation();
    if (business.links?.site && !isBlogger) {
        return (
            <ClickOutButton
                text={
                    business.links?.shortSite || business.links?.siteDisplay || business.links?.site
                }
                url={business.links?.site}
                onClick={onClickOutClick}
                {...other}
            />
        );
    }

    return (
        <Button
            {...other}
            flexGrow={1}
            variant="filled"
            size="m"
            color="secondary"
            spacing={0.5}
            onClick={onShare}
        >
            <IconShare size={20} />
            {t('Поделиться')}
        </Button>
    );
};
